import { Redirect } from "react-router-dom";
import { LoginBoxStyled, LoginStyled } from "./styled/LoginStyled";
import { useSelector } from "react-redux";
import { getLoggedIn } from "../authSelectors";
import RouterPaths from "../../../app/routePaths";
import Forgot from "./Forgot";

export default function ForgotPage() {
    const isLoggedIn = useSelector(getLoggedIn);

    if (isLoggedIn) {
        return <Redirect to={RouterPaths.main}/>
    }

    return <>
        <LoginStyled>
            <LoginBoxStyled>
                <Forgot/>
            </LoginBoxStyled>
        </LoginStyled>
    </>
}
